/*
Author: Chathuraka Mallawa Arachchi
Date: 01/01/2025
Copyright © 2025 Infix!. All rights reserved.
*/

import {Box} from '@/components/Atoms/';
import Header from '@/components/Molecule/Header';
import {Session} from '@/utils';
import {Navigate,Outlet} from 'react-router-dom';
import "../../styles.css";
import {useUrlType} from '../hooks';

export default function DefaultLayout() {
    const {isPatient} = useUrlType();
    if (!Session.isAuthenticated()) {
        return (
            <Navigate
                to={{
                    pathname: '/home',
                }}
                state={{ from: window.location.pathname }}
                replace
            />
        );
    }

    return (
        <div className={`${isPatient ? "patient-theme ": "poa-theme"} h-screen flex flex-col`}>
            <Header/>
            <Box className='flex flex-col md:flex-row min-h-screen'>
                {/* {isPatient ? <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} /> : null}
                
               {isPatient ? <main className={`${sidebarOpen ? 'w-5/6 bg-white' : 'w-full'}`.trim()}>
                    <Box className="body">
                        <Outlet /> 
                    </Box>
                </main> : <main className={`w-full`}>
                    <Box className="body">
                        <Outlet /> 
                    </Box>
                </main> }  */}
                {isPatient ? <main className={`w-full flex justify-center`}>
                    <Box className={`body patient`}>
                        <Outlet /> 
                    </Box>
                </main>  : <main className={`w-full`}>
                    <Box className={`body poa`}>
                        <Outlet /> 
                    </Box>
                </main>}
            </Box>
        </div>
    );
}
